
import { Component, Vue, Prop } from "vue-property-decorator";
import { TenantSettings } from "@shared/core/services/configService";
import { Format } from "@shared/core/helpers/formatHelper";

@Component({
  components: {},
})
export default class FooterMobile extends Vue {
  @Prop({ default: false }) settings!: TenantSettings;

  goToHome() {
    this.$router.push("/");
  }

  getAddressMaps(coords: any) {
    if (Format.IsNull(coords)) {
      return "#";
    }
    const splited = coords.split(",");
    if (splited.length !== 2) {
      return "#";
    }
    return "https://www.google.com/maps/place/" + splited[0] + "," + splited[1];
  }

  getPhone(phone: string | null | undefined){
    if (Format.IsNull(phone)) {
      return "#";
    }
    return `tel:${phone}`;
  }
}
